<template>
    <div>
        <main-layout :ShowBottomBar="false" :NeedLogin="false" :ResizeCallback="Resize">
            <div class="definition">
                <el-row>
                    <el-col :span="24">
                        <div class="title">
                            <img src="../assets/img/dictionary.svg" class="iconMark"> xAPI Verbs
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="24">
                        <el-table :data="tableData" style="width: 95%;font-size:small" v-bind:style="{height: this.TableHeight + 'px'}">
                            <el-table-column prop="Name" label="Name" width="150">
                            </el-table-column>
                            <el-table-column prop="Description" label="Description">
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </div>
        </main-layout>

    </div>
</template>
<style scoped>
.definition {
    font-family: 'HelveticaNeue-Medium';
    padding-left: 28px;
}

</style>
<script>
import * as d3 from 'd3-collection'
import * as lib from '../lib/lib.js'
import MainLayout from '../components/MainLayout.vue'

export default {
    data() {
        return {
            TableHeight: window.innerHeight - 244,
            dialogFormVisible: false
        }
    },
    computed: {
        tableData: function() {
            return [{ Name: this.$store.state.route.params["name"], Description: "This is the description" }]
        }
    },
    created: function() {

    },
    methods: {
        Resize: function() {
            let height = window.innerHeight - 145 - 137 - 20
            this.TableHeight = height <= 250 ? 250 : height
        }
    },
    mounted: function() {

    },
    components: {
        MainLayout
    }
}
</script>




// WEBPACK FOOTER //
// Schema.vue?a431dd12